/**
 * Universal Collapse Component
 */
(function ($) {

    $( document ).on('click', '[data-collapse]', function (e) {
        e.preventDefault();

        var targetCollapse = $( this ).data('collapse');

        $( this ).toggleClass('is-active');
        $( targetCollapse ).slideToggle();
    
    });

})(jQuery);